import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/shared/ui/card';
import { Badge } from '@/shared/ui/badge';

interface SkillCategoryProps {
  title: string;
  skills: string[];
}

export const SkillCategory: React.FC<SkillCategoryProps> = ({
  title,
  skills,
}) => {
  return (
    <Card className="h-full">
      <CardHeader>
        <CardTitle className="text-lg tracking-tight">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-wrap gap-2">
          {skills.map((skill) => (
            <Badge key={skill} variant="secondary" className="font-mono">
              {skill}
            </Badge>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
